import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.anchor.js";
var render = function render() {
  var _vm$groupedItemsByDep, _vm$groupedItemsByDep2, _vm$itemsRequiringTas;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "container-centered small text-left"
  }, [_vm.order.items.length == 0 ? _c("div", [_c("h3", {
    staticClass: "text-center"
  }, [_vm._v("Your cart is empty")])]) : _vm.order.items.length > 0 ? _c("div", {
    staticClass: "order-maincontent"
  }, [_c("div", {
    staticClass: "order-maincontent-data"
  }, [_c("h3", [_vm._v("Order Information")]), _c("div", [_c("div", [_vm._m(0), _c("div", {
    class: ["order-maincontent-data-value", _vm.canManageUsers ? "text-underline" : ""]
  }, [_vm.canManageUsers ? _c("router-link", {
    attrs: {
      to: _vm.goToUserEdit(_vm.order.user)
    }
  }, [_c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.userData)
    }
  })]) : _c("div", {
    domProps: {
      innerHTML: _vm._s(_vm.userData)
    }
  })], 1)]), _c("div", [_vm._m(1), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [_c("div", [_vm._v(_vm._s(_vm.order.user.phone))]), _c("div", [_vm._v(_vm._s(_vm.order.user.login))])])])]), _c("div", [_c("div", {
    staticClass: "delivery-instructions"
  }, [_c("div", [_vm._m(2), _vm.isInboundAvailable ? _c("div", {
    staticClass: "mb-2"
  }, [_c(VCheckbox, {
    staticClass: "cursor--forbidden",
    attrs: {
      label: "Deliver as available stock",
      readonly: "",
      "hide-details": "auto"
    }
  }), _c("div", {
    staticClass: "text-warning text-smaller text-italic"
  }, [_vm._v(" Will be available at next step ")])], 1) : _vm._e(), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [!_vm.editingDeliveryInstructions ? [_c("div", {
    staticClass: "flex --baseline"
  }, [_c("div", {
    staticClass: "text-smaller",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.order.delivery_instructions) || "No specific instruction")
    }
  }), _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    on: {
      click: _vm.startEditDeliveryInstructions
    }
  })], 1)] : [_c(VTextarea, {
    ref: "inputDeliveryInstruction",
    staticClass: "delivery-instructions-textarea",
    attrs: {
      rows: "3",
      filled: "",
      placeholder: "Write your instructions here",
      "hide-details": "auto"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        $event.preventDefault();
        return _vm.updateDeliveryInstructions.apply(null, arguments);
      }
    },
    model: {
      value: _vm.order.delivery_instructions,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "delivery_instructions", $$v);
      },
      expression: "order.delivery_instructions"
    }
  }), _c(VCheckbox, {
    attrs: {
      label: "Save for next purchases"
    },
    model: {
      value: _vm.isSetDeliveryAddressAsDefaultForUserAddress,
      callback: function callback($$v) {
        _vm.isSetDeliveryAddressAsDefaultForUserAddress = $$v;
      },
      expression: "isSetDeliveryAddressAsDefaultForUserAddress"
    }
  }), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.updateDeliveryInstructions
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-arrow-right",
    staticStyle: {
      "margin-right": "0.25rem"
    },
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save delivery instructions ")], 1)]], 2)])]), _vm.canChangeCurrency ? _c("div", [_c("div", [_vm._m(3), _c("div", {
    staticClass: "order-maincontent-data-value"
  }, [!_vm.editingOrderCurrency ? [_c("div", {
    staticClass: "flex --baseline"
  }, [_c("div", {
    staticClass: "text-smaller",
    domProps: {
      innerHTML: _vm._s(String.nl2br(_vm.listCurrencies.find(function (x) {
        return x.id === _vm.order.currency;
      }).name))
    }
  }), _c(VIcon, {
    staticClass: "fa fa-pen text-sm ml-2 icon-link",
    on: {
      click: _vm.startEditOrderCurrency
    }
  })], 1)] : [_c(VAutocomplete, {
    ref: "inputOrderCurrency",
    staticClass: "v-text-field-no-label",
    attrs: {
      items: _vm.listDefaultCurrencies,
      disabled: _vm.isUpdatingOrderCurrency,
      "item-value": "id",
      "item-text": "name",
      "hide-no-data": "",
      "hide-selected": "",
      "hide-details": "auto"
    },
    on: {
      change: _vm.updateOrderCurrency,
      blur: function blur() {
        if (_vm.initialCurrency === _vm.order.currency) {
          _vm.editingOrderCurrency = false;
        }
      }
    },
    model: {
      value: _vm.order.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.order, "currency", $$v);
      },
      expression: "order.currency"
    }
  })]], 2)])]) : _vm._e()]), _vm.getOrderTotalIncludeCreditNoteCurrency() > 0 ? _c("div", {
    staticClass: "--one-column"
  }, [_c("div", {
    staticClass: "order-maincontent-data-total"
  }, [_c("div", [_vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.getOrderTotalIncludeCreditNoteCurrency())) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " * ")]), !_vm.orderHasMultipleDepartures ? _c("div", {
    staticClass: "text-tax-info"
  }, [((_vm$groupedItemsByDep = _vm.groupedItemsByDeparture[0]) === null || _vm$groupedItemsByDep === void 0 ? void 0 : _vm$groupedItemsByDep.expeditionMethod) === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2) : _vm._e()])]) : _vm._e()]), _c("div", {
    staticClass: "order-maincontent-summary",
    class: [_vm.isFetchingShippingCosts && "--disabled"],
    attrs: {
      id: "order-summary"
    }
  }, [_c("h3", [_vm._v(" Order Summary "), _c("span", {
    staticClass: "nb-items"
  }, [_vm._v(" : " + _vm._s(_vm.getOrderNbItems) + " Bottle" + _vm._s(_vm.getOrderNbItems > 1 ? "s" : "") + " ")])]), _vm.isFetchingShippingCosts && !((_vm$groupedItemsByDep2 = _vm.groupedItemsByDeparture) !== null && _vm$groupedItemsByDep2 !== void 0 && _vm$groupedItemsByDep2.length) ? _vm._l(3, function (i) {
    return _c("div", {
      key: i
    }, [_c(VSkeletonLoader, {
      staticClass: "my-1",
      attrs: {
        width: "100%",
        type: "list-item-avatar-three-line"
      }
    })], 1);
  }) : _vm._l(_vm.groupedItemsByDeparture, function (groupedItems, ii) {
    var _vm$getAnyShippingMet, _vm$expedition_method, _vm$getAnyGroupedItem, _vm$order, _vm$order2, _vm$order$expedition_, _vm$order3, _vm$order4, _vm$order5;
    return _c("div", {
      key: ii,
      attrs: {
        id: "order-summary-".concat(ii)
      }
    }, [_c("div", {
      staticClass: "my-2",
      attrs: {
        id: "items_" + ((_vm$getAnyShippingMet = _vm.getAnyShippingMethod(groupedItems)) === null || _vm$getAnyShippingMet === void 0 ? void 0 : _vm$getAnyShippingMet.id)
      }
    }, [_vm._v(" From "), _c("strong", [_vm._v(" " + _vm._s(_vm.getAnyShippingMethod(groupedItems).departureCountry) + " " + _vm._s(" (".concat(_vm.getAnyShippingMethod(groupedItems).departureWarehouseName, ")")) + " ")])]), _c("div", {
      staticClass: "order-maincontent-summary-items mt-4"
    }, [_vm._l(groupedItems, function (item) {
      var _item$wine, _item$wine2, _item$item_provenance;
      return _c("div", {
        key: item.id_item,
        staticClass: "item-row",
        class: [!_vm.isActiveItem(item) && "disabled-like", _vm.isCollapsed && "collapse"]
      }, [_c("div", {
        staticClass: "item-row-img"
      }, [!_vm.imagesBroken.includes(item.id_item) && (_item$wine = item.wine) !== null && _item$wine !== void 0 && _item$wine.imageThumbnail ? _c("img", {
        attrs: {
          src: item.wine.imageThumbnail,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(item.id_item);
          }
        }
      }) : !_vm.imagesBroken.includes(item.id_item) && (_item$wine2 = item.wine) !== null && _item$wine2 !== void 0 && _item$wine2.image ? _c("img", {
        attrs: {
          src: item.wine.image,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(item.id_item);
          }
        }
      }) : _c("img", {
        attrs: {
          src: require("@/assets/images/_temp/wine_default_primary_img.png"),
          alt: ""
        }
      })]), _c("div", {
        staticClass: "item-row-informations"
      }, [_c("div", {
        staticClass: "item-row-winename"
      }, [_c("router-link", {
        staticClass: "router-link",
        attrs: {
          to: _vm.productDetails(item.wine)
        }
      }, [_c("wine-naming", {
        key: "wine-naming-".concat(item.wine.id_wine),
        attrs: {
          wineNamingData: item.wine.naming_data,
          isPrefixWinery: true,
          isSuffixBottling: true,
          isSuffixType: true
        }
      })], 1), _c("div", {
        staticClass: "item-row-provenance"
      }, [item.isDirectWinery ? [_vm._v(" From winery, " + _vm._s(item.wine.sku) + ", " + _vm._s(_vm.computeAddressStockConsignment(item)) + " ")] : [_vm._v(" From " + _vm._s(item.warehouseName) + ", " + _vm._s(item.wine.sku) + " ")], (_item$item_provenance = item.item_provenances) !== null && _item$item_provenance !== void 0 && _item$item_provenance.some(function (ip) {
        return ip.stockPart.status === _vm.STOCK_PART.STATUS.PRESELL.id;
      }) ? _c("span", {
        staticClass: "badge warning --small --padding ml-1"
      }, [_vm._v(" #PRE-ARRIVAL ")]) : _vm._e()], 2)], 1), _c("div", {
        staticClass: "item-row-lineprices"
      }, [item.cogs_forced === null ? _c("WineDiscountTooltip", {
        staticClass: "wine-discount",
        attrs: {
          wine: item.wine,
          currency: _vm.order.currency
        }
      }) : _vm._e(), _c("div", {
        staticClass: "item-row-quantity"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Qty")]), _c("div", [_c(VTextField, {
        key: _vm.quantityToggleKey,
        staticClass: "ma-0 pa-0 text-center",
        attrs: {
          type: "number",
          value: item.quantity / item.casingId.match(/\d+/)[0],
          min: 1,
          disabled: !_vm.isActiveItem(item)
        },
        on: {
          change: function change($event) {
            return _vm.changeQuantityOrder(item, $event, groupedItems);
          },
          keypress: _vm.filterIntegerKey
        }
      })], 1)])]), _c("div", {
        staticClass: "item-row-conditionment"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Casing")]), _c("div", [_c(VSelect, {
        staticClass: "v-text-field-no-label",
        attrs: {
          items: item.wine.casings,
          disabled: !_vm.isActiveItem(item),
          "item-value": "casingId",
          "item-text": "textCard",
          "hide-details": "auto"
        },
        on: {
          change: function change($event) {
            return _vm.changeQuantityOrder(item, 1, groupedItems);
          }
        },
        scopedSlots: _vm._u([{
          key: "item",
          fn: function fn(_ref) {
            var item = _ref.item;
            return [_c("div", {
              class: !item.id ? "text-card-warning" : ""
            }, [_vm._v(" " + _vm._s(item.textCard) + " ")])];
          }
        }], null, true),
        model: {
          value: item.casingId,
          callback: function callback($$v) {
            _vm.$set(item, "casingId", $$v);
          },
          expression: "item.casingId"
        }
      })], 1)])]), _c("div", {
        staticClass: "item-row-unitprice"
      }, [_c("div", [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Case price")]), _c("div", {
        staticStyle: {
          display: "flex"
        }
      }, [_vm.isAuthorizedToEditItemPrice ? _c("div", {
        staticClass: "item-row-lineprices-edit"
      }, [_c("a", {
        staticClass: "fas fa-edit text-decoration-none",
        attrs: {
          title: "Edit price"
        },
        on: {
          click: function click($event) {
            return _vm.editItemPrice(item);
          }
        }
      })]) : _vm._e(), _c("div", [_c("div", {
        staticClass: "item-row-lineprices-maindata text-nowrap"
      }, [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, groupedItems) * item.casingId.match(/\d+/)[0]), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " ")]), item.casingId !== "OC1" && item.casingId !== "OWC1" ? _c("div", {
        staticClass: "text-tax-info text-no-transform"
      }, [_vm._v(" " + _vm._s("".concat(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, groupedItems)), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " / bottle ")]) : _vm._e()])])])]), _c("div", {
        staticClass: "item-row-totalprice"
      }, [_c("div", {
        staticClass: "item-row-lineprices-title"
      }, [_vm._v("Total")]), _c("div", {
        staticClass: "item-row-lineprices-maindata text-nowrap"
      }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.getUnitPriceCurrencyForItem(item, groupedItems) * item.quantity)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")]), _c("div", {
        staticClass: "text-tax-info"
      }, [item.expeditionMethod === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2)]), _vm.isChangeStockAvailable(item) ? _c("div", {
        staticClass: "item-row-remove"
      }, [_c("a", {
        staticClass: "fas fa-exchange-alt text-decoration-none",
        attrs: {
          title: "Change stock"
        },
        on: {
          click: function click($event) {
            return _vm.changeStockItem(item, groupedItems);
          }
        }
      })]) : _vm._e(), _c("div", {
        staticClass: "item-row-remove"
      }, [_c("a", {
        staticClass: "far fa-trash-alt text-decoration-none",
        attrs: {
          title: "Remove"
        },
        on: {
          click: function click($event) {
            return _vm.deleteItem(item.id_item);
          }
        }
      })])], 1), _vm.order.isBypassBuyLimits && (item.quantity > item.wine.buy_limit || item.isExceedingBuyLimitForYear) ? _c("div", {
        staticClass: "item-row-bypass-buylimits"
      }, [_c(VAlert, {
        staticClass: "bypass-message --small",
        attrs: {
          dense: "",
          outlined: "",
          type: "warning",
          color: "orange",
          text: ""
        }
      }, [_vm._v(" Quantity exceeds the customer's annual buy limit. ")])], 1) : _vm._e()])]);
    }), (groupedItems === null || groupedItems === void 0 ? void 0 : groupedItems.length) > 4 ? _c("div", {
      staticClass: "items-collapsis"
    }, [_vm.isCollapsed ? _c("div", {
      staticClass: "overlay"
    }) : _vm._e(), _vm.isCollapsed ? _c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "info",
        text: ""
      }
    }, [_vm._v(" " + _vm._s("Click below to show the ".concat(groupedItems.length - 4, " other reference").concat(groupedItems.length - 4 > 1 ? "s" : "", " of this order")) + " ")]) : _vm._e(), _c(VBtn, {
      on: {
        click: function click($event) {
          return _vm.collapse(ii);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        dark: ""
      }
    }, [_vm._v(_vm._s(_vm.isCollapsed ? "mdi-chevron-down" : "mdi-chevron-up"))])], 1)], 1) : _vm._e(), _c("div", {
      staticClass: "order-maincontent-data-shippingmethod-edit --one-column"
    }, [_vm._m(4, true), _c("div", {
      staticClass: "mb-2"
    }, [_c(VCheckbox, {
      staticStyle: {
        "margin-bottom": "-1rem !important",
        width: "fit-content"
      },
      attrs: {
        disabled: _vm.isEditingShippingQuantity,
        id: "isShippingQuantity",
        label: "Simulate number of regular bottles of the shipping, for shipping prices"
      },
      on: {
        change: function change($event) {
          return _vm.editShippingQuantity(true);
        }
      },
      model: {
        value: _vm.isShippingQuantity,
        callback: function callback($$v) {
          _vm.isShippingQuantity = $$v;
        },
        expression: "isShippingQuantity"
      }
    }), _vm.isShippingQuantity ? _c("div", {
      staticClass: "d-inline-flex"
    }, [_c(VTextField, {
      staticClass: "ma-0 pa-0 text-center",
      attrs: {
        disabled: _vm.isEditingShippingQuantity,
        type: "number",
        min: 0
      },
      on: {
        change: function change($event) {
          return _vm.editShippingQuantity();
        },
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: _vm.order.shipping_quantity,
        callback: function callback($$v) {
          _vm.$set(_vm.order, "shipping_quantity", $$v);
        },
        expression: "order.shipping_quantity"
      }
    })], 1) : _vm._e()], 1), _c("div", [((_vm$expedition_method = _vm.expedition_methods) === null || _vm$expedition_method === void 0 ? void 0 : _vm$expedition_method.length) === 0 || _vm.isFetchingShippingCosts ? _c(VSkeletonLoader, {
      attrs: {
        width: "100%",
        type: "heading"
      }
    }) : [_vm.isShippingInErrorEvenSuperAdmin(groupedItems) ? [_c("div", {
      staticClass: "flex"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "red",
        text: ""
      }
    }, [_vm._v(" There is no shipping method available. Please add a shipping method for this departure and arrival, and refresh. ")])], 1), _c(VBtn, {
      staticClass: "btn-ship-choice mt-2",
      attrs: {
        loading: _vm.isFetchingShippingCosts
      },
      on: {
        click: function click($event) {
          return _vm.getChargesForOrder(true);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        left: "",
        small: "",
        dark: ""
      }
    }, [_vm._v("fas fa-sync")]), _vm._v(" Refresh ")], 1)] : _c(VBtnToggle, {
      staticClass: "btn-group",
      attrs: {
        tile: "",
        group: "",
        mandatory: ((_vm$getAnyGroupedItem = _vm.getAnyGroupedItem(groupedItems)) === null || _vm$getAnyGroupedItem === void 0 ? void 0 : _vm$getAnyGroupedItem.shippingMethods.length) === 1,
        items: _vm.expedition_methods
      },
      model: {
        value: _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId],
        callback: function callback($$v) {
          _vm.$set(_vm.order.expedition_methods, _vm.getAnyShippingMethod(groupedItems).departureWarehouseId, $$v);
        },
        expression: "\n                        order.expedition_methods[\n                          getAnyShippingMethod(groupedItems).departureWarehouseId\n                        ]\n                      "
      }
    }, _vm._l(_vm.getAnyGroupedItem(groupedItems).shippingMethods, function (shipItem) {
      return _c(VBtn, {
        key: shipItem.id,
        staticClass: "btn-group-btn btn-ship-choice",
        attrs: {
          value: shipItem
        },
        on: {
          click: function click($event) {
            return _vm.changeExpeditionMethod(shipItem, groupedItems);
          }
        }
      }, [_c("div", [_c("div", [_c("i", {
        class: "fas ".concat(shipItem.icon)
      }), _vm._v(" " + _vm._s(shipItem.label) + " ")]), shipItem.id === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v(" Manage the pickup on my own ")]), _c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v("Shipping & tax free")])] : [_c("div", {
        staticClass: "btn-ship-choice-important-data"
      }, [_vm._v(" ETA : " + _vm._s(shipItem.eta_label) + " ")]), _c("div", {
        staticClass: "btn-ship-choice-important-data",
        domProps: {
          innerHTML: _vm._s(_vm.showShippingPriceMinusDefault(shipItem, groupedItems))
        }
      })]], 2)]);
    }), 1), _vm.errorLabels.shipping[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId] ? _c("div", {
      staticClass: "errorLabel"
    }, [_vm._v(" " + _vm._s(_vm.errorLabels.shipping[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId]) + " ")]) : _vm._e(), !_vm.isShippingInErrorEvenSuperAdmin(groupedItems) && (_vm$order = _vm.order) !== null && _vm$order !== void 0 && _vm$order.expedition_methods && _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId] && _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].id !== _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", {
      staticClass: "eta text-left"
    }, [_vm.shouldShowWarningDefaultShipping(groupedItems) ? _c("div", {
      staticClass: "mb-1"
    }, [_vm._v(" To qualify for free shipping fee, please increase your order to 120 regular bottles or a total of 90 liters. ")]) : _vm._e(), _c("div", [_vm._v(" Estimated time of arrival, from warehouse departure : "), _c("strong", [_vm._v(" " + _vm._s(_vm.getEtaLabel(_vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].eta_min_hours, _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].eta_max_hours)) + " ")])])]) : _vm._e(), !_vm.isShippingInErrorEvenSuperAdmin(groupedItems) && _vm.isShippingInError(groupedItems) ? [_vm.isShippingOutOfRange(groupedItems) ? _c("div", {
      staticClass: "flex"
    }, [_c(VAlert, {
      staticClass: "--small-2",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" " + _vm._s(_vm.getShippingOutOfRangeMessage(groupedItems)) + " ")])], 1) : _vm._e()] : _vm._e()]], 2), (_vm$order2 = _vm.order) !== null && _vm$order2 !== void 0 && _vm$order2.expedition_methods && ((_vm$order$expedition_ = _vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId]) === null || _vm$order$expedition_ === void 0 ? void 0 : _vm$order$expedition_.id) === _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", {
      staticClass: "mt-3"
    }, [_vm._m(5, true), _c("StorageTermsReference")], 1) : _vm._e()])], 2), _c("div", {
      staticClass: "order-maincontent-summary-linetotal"
    }, [_c("div", {
      staticClass: "order-maincontent-summary-linetotal-shipping"
    }, [_vm.isShippingSetAvailable(groupedItems) && !_vm.isChangingQuantity && ((_vm$order3 = _vm.order) === null || _vm$order3 === void 0 ? void 0 : _vm$order3.expedition_method) !== _vm.expeditionMethods.CELLAR_STORAGE.id && (_vm$order4 = _vm.order) !== null && _vm$order4 !== void 0 && _vm$order4.expedition_methods && ((_vm$order5 = _vm.order) === null || _vm$order5 === void 0 || (_vm$order5 = _vm$order5.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId]) === null || _vm$order5 === void 0 ? void 0 : _vm$order5.id) !== _vm.expeditionMethods.CELLAR_STORAGE.id ? _c("div", [_vm._v(" Complete Logistic "), _c("span", [_vm._v(" ≃ "), !!_vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId] && !_vm.isChangingQuantity ? [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].price_numeric_currency / groupedItems.reduce(function (acc, x) {
      return acc + x.quantity;
    }, 0))) + " ")] : [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.amount_shipping_currency / _vm.nbBottles)) + " ")], _vm._v(" " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " / bottle ")], 2), _c("span", [_vm._v(" : "), !!_vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId] && !_vm.isChangingQuantity ? [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.expedition_methods[_vm.getAnyShippingMethod(groupedItems).departureWarehouseId].price_numeric_currency)) + " ")] : [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.amount_shipping_currency || 0)) + " ")], _vm._v(" " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")], 2)]) : _vm._e()]), _vm.orderHasMultipleDepartures ? _c("div", {
      staticClass: "order-maincontent-summary-linetotal-total mt-2"
    }, [_c("div", [_vm._v(" Subtotal : " + _vm._s("".concat(_vm.formatPrice(_vm.getSubtotalPriceForDeparture(groupedItems)), " ").concat(_vm.getSymbolCurrency(_vm.order.currency))) + " * ")]), _c("div", {
      staticClass: "text-tax-info"
    }, [_vm.getAnyGroupedItem(groupedItems).expeditionMethod === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2)]) : _vm._e()])]);
  }), _vm.getOrderTotalIncludeCreditNoteCurrency() > 0 ? _c("div", {
    staticClass: "--one-column"
  }, [_c(VDivider, {
    staticClass: "my-5"
  }), _c("div", {
    staticClass: "order-maincontent-data-total"
  }, [_c("div", [_vm._v(" Total : " + _vm._s(_vm.formatPrice(_vm.getOrderTotalIncludeCreditNoteCurrency())) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " * ")]), !_vm.orderHasMultipleDepartures ? _c("div", {
    staticClass: "text-tax-info"
  }, [_vm.order.expedition_method === _vm.expeditionMethods.CELLAR_STORAGE.id ? [_c("div", [_vm._v(_vm._s(" duties & taxes free"))])] : _vm.isConcernedByVat ? [_vm.isOrderForIndividualUs ? [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])] : [_vm.isGreatExport ? _c("div", [_vm._v(_vm._s(" incl. duty & tax"))]) : _c("div", [_vm._v(_vm._s(" incl. sales tax"))])]] : [_c("div", [_vm._v(_vm._s(" incl. import duties & taxes"))]), _c("div", [_vm._v(_vm._s(" ex vat/gst"))])]], 2) : _vm._e()])], 1) : _vm._e()], 2)]) : _vm._e()]), _vm.order.items.length != 0 ? _c("div", {
    staticClass: "order-bottom-content container-centered small"
  }, [_vm._m(6), ((_vm$itemsRequiringTas = _vm.itemsRequiringTastingPhoto) === null || _vm$itemsRequiringTas === void 0 ? void 0 : _vm$itemsRequiringTas.length) > 0 ? _c("div", {
    staticClass: "order-bottom-content-acceptterms",
    staticStyle: {
      "margin-top": "0.4rem"
    }
  }, [_c("div", {
    staticClass: "order-bottom-content-acceptterms-tastingPhoto-container"
  }, _vm._l(_vm.itemsRequiringTastingPhoto, function (itemRequiring) {
    return _c("div", {
      key: "tastingPhoto-chkbox-" + itemRequiring.id_item,
      staticClass: "order-bottom-content-acceptterms-tastingPhoto"
    }, [_c(VCheckbox, {
      model: {
        value: _vm.checkboxTastingPhoto[itemRequiring.id_item],
        callback: function callback($$v) {
          _vm.$set(_vm.checkboxTastingPhoto, itemRequiring.id_item, $$v);
        },
        expression: "checkboxTastingPhoto[itemRequiring.id_item]"
      }
    }, [_c("div", {
      staticClass: "order-bottom-content-acceptterms-tastingPhoto-label",
      attrs: {
        slot: "label"
      },
      slot: "label"
    }, [_vm._v(" I notified the customer to take a photo of each bottle of «" + _vm._s(_vm.wineNaming(_vm.$whitelabel, itemRequiring.wine.naming_data, true, true, true)) + "» at the time of its tasting. ")])])], 1);
  }), 0)]) : _vm._e()]) : _vm._e(), _c("div", {
    staticClass: "button-end-page-container"
  }, [_vm.order.items.length > 0 ? _c("div", [_vm.errorLabels.quantity_orders.length > 0 ? _c("p", {
    staticClass: "errorLabel text-center text-underline pointer",
    on: {
      click: function click($event) {
        return _vm.scrollTo("#items_" + _vm.errorLabels.quantity_orders[0].anchor);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.quantity_orders[0].text) + " ")]) : _vm._e(), _vm.errorLabels.tastingPhoto.length > 0 ? _c("div", {
    staticClass: "errorLabel text-center"
  }, [_vm._v(" " + _vm._s(_vm.errorLabels.tastingPhoto) + " ")]) : _vm._e(), !!Object.values(_vm.errorLabels.shipping).length ? _c("div", {
    staticClass: "errorLabel text-center mb-2"
  }, [_vm._v(" A shipping type is missing on some items ")]) : _vm._e(), _c("div", {
    staticClass: "text-smaller text-italic text-center"
  }, [_vm._v(" Mail title : Order waiting for validation ")]), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.sendOrderToUser();
      }
    }
  }, [_vm._v(" Send to customer ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.confirmOrderForCustomer();
      }
    }
  }, [_vm._v(" Confirm order without sending to customer ")])], 1)]) : _vm._e()]), _c("WineStockListModal", {
    key: _vm.wineStockKey,
    ref: "WineStockListModal",
    attrs: {
      wine: _vm.currentWine,
      quantity: _vm.currentQuantity,
      casingId: _vm.currentCasingId,
      order: _vm.order,
      isBasket: true,
      isUsedStockSwitchable: true,
      add: _vm.addWineFromWineStockList
    },
    on: {
      closed: _vm.closeWineStockListModal
    }
  }), _vm.editOrderItemPriceDialogShown ? _c("EditOrderItemPriceDialog", {
    ref: "EditOrderItemPriceDialog",
    attrs: {
      item: _vm.currentItemForWineStockChanged
    },
    on: {
      confirmed: _vm.confirmItemPrice,
      closed: _vm.cancelEditOrderItemPriceDialog
    }
  }) : _vm._e(), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-user"
  }), _vm._v(" Customer ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-phone"
  }), _vm._v(" Customer contacts ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck-loading"
  }), _vm._v(" Delivery instructions ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-coins"
  }), _vm._v(" Currency ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-truck"
  }), _vm._v(" Shipping type ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("span", {
    staticClass: "free-storage-text"
  }, [_vm._v("Free storage for 3 months.")]), _c("br"), _vm._v(" A notification asking to collect the goods will be sent every month "), _c("strong", [_vm._v("for 2 months")]), _vm._v(" , then every week "), _c("strong", [_vm._v("for the last month.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "order-bottom-content-incoterms"
  }, [_c("div", [_c("div", {
    staticClass: "text-incoterms"
  }, [_vm._v(" *Sold in delivered duty paid incoterm only if you have not selected stored in the cellar. Delivered duty paid is a delivery agreement whereby the seller assumes all of the responsibility, risk, and costs associated with transporting goods until the buyer receives or transfers them at the destination port. This agreement includes paying for shipping costs, export and import duties, insurance, and any other expenses incurred during shipping to an agreed-upon location in the buyer's country. ")]), _c("div", {
    staticClass: "text-incoterms"
  }, [_vm._v("All items are subject to availability.")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };